const config = {
  token: process.env.TOKEN,
  WEB_APP_URL: process.env.WEB_APP_URL,
  ipInfoToken: process.env.IPINFO_TOKEN,
  PORT: process.env.PORT,
  mongoDBURL: process.env.MONGO_DB_URL,
  URL_SERVER: process.env.URL_SERVER,
};

export default config;
